import { render, staticRenderFns } from "./CTAngiography_v2.vue?vue&type=template&id=9f0c263e&"
import script from "./CTAngiography_v2.vue?vue&type=script&lang=ts&"
export * from "./CTAngiography_v2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f0c263e')) {
      api.createRecord('9f0c263e', component.options)
    } else {
      api.reload('9f0c263e', component.options)
    }
    module.hot.accept("./CTAngiography_v2.vue?vue&type=template&id=9f0c263e&", function () {
      api.rerender('9f0c263e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/investigations/advanced/CTAngiography_v2.vue"
export default component.exports